export default {
	name	: 'MainButton',
	props	: {
		label	: {
			type		: String,
			required	: true
		},
		disabled: {
			type		: Boolean,
			default		: false
		},
		loading	: {
			type		: Boolean,
			default		: false
		},
		type	: {
			type		: String,
			default		: 'button'
		}
	}
}
